import P from 'prop-types';
import { useReducer } from 'react';
import { MenuLoggedContext } from './context';
import { data } from './data';
import { reducer } from './reducer';

export const MenuLoggedProvider = ({ children }) => {
  const [menuLoggedState, menuLoggedDispatch] = useReducer(reducer, data);

  return (
    <MenuLoggedContext.Provider value={{ menuLoggedState, menuLoggedDispatch }}>
      {children}
    </MenuLoggedContext.Provider>
  );
};

MenuLoggedProvider.propTypes = {
  children: P.node.isRequired,
};
